import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FilterExpanderWithListOfCheckboxes } from '../../../../components/CustomExpander/componenets/filter-expander-with-list-of-checkboxes';
import { ProfessorsSalariesStatusesType } from '../../../../api/types/accountants/salaries-statuses/professors-salaries-statuses.type';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

export interface SalaryLecturerListProps {
  professorStatuses: ProfessorsSalariesStatusesType | undefined;
  onUserSelected?: (user: UserSummaryType) => void;
  onSelectionChange?: (selectedUserIds: number[]) => void;
  multiple?: boolean;
}

export const SalaryLecturerList: React.FC<SalaryLecturerListProps> = observer(
  ({
    professorStatuses,
    onUserSelected,
    onSelectionChange,
    multiple = false,
  }) => {
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedOpenAccountUsers, setSelectedOpenAccountUsers] = useState<
      number[]
    >([]);
    const [selectedClosedAccountUsers, setSelectedClosedAccountUsers] =
      useState<number[]>([]);

    const handleOpenAccountUserToggle = (userId: number) => {
      setSelectedOpenAccountUsers((prev) => {
        const next = prev.includes(userId)
          ? prev.filter((id) => id !== userId)
          : [...prev, userId];
        onSelectionChange?.(next);
        return next;
      });

      setSelectedUserId(userId);

      if (!multiple) {
        const user = (professorStatuses?.pending ?? []).find(
          (u) => u.id === userId,
        );
        if (user) {
          onUserSelected?.(user);
        }
      }
    };

    const handleOpenAccountSelectionSet = (selectedIds: number[]) => {
      setSelectedOpenAccountUsers(selectedIds);
      onSelectionChange?.(selectedIds);
      setSelectedUserId(selectedIds.length > 0 ? selectedIds[0] : null);
    };

    const handleClosedAccountUserToggle = (userId: number) => {
      const isCurrentlySelected = selectedClosedAccountUsers.includes(userId);

      setSelectedClosedAccountUsers((prev) =>
        isCurrentlySelected
          ? prev.filter((id) => id !== userId)
          : [...prev, userId],
      );

      setSelectedUserId(userId);

      // Trigger HTTP request immediately
      if (!isCurrentlySelected) {
        const user = (professorStatuses?.pending ?? []).find(
          (u) => u.id === userId,
        );
        if (user) {
          onUserSelected(user);
        }
      }
    };

    const styles = {
      container: {
        width: '250px',
        maxWidth: '250px',
        minWidth: '250px',
        height: 'calc(100vh - 400px)', // Leave space for date filters above
        maxHeight: 'calc(100vh - 400px)',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column' as const,
      },
      header: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
      },
      content: {
        flex: 1,
        overflowY: 'auto' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        paddingRight: '4px',
      },
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>מרצים</div>
        <div style={styles.content}>
          <FilterExpanderWithListOfCheckboxes
            title="מרצים בחשבון פתוח"
            items={professorStatuses?.pending ?? []}
            selectedItems={selectedOpenAccountUsers}
            onItemToggle={handleOpenAccountUserToggle}
            onSelectionSet={
              multiple ? handleOpenAccountSelectionSet : undefined
            }
            getItemLabel={(user) => `${user.firstName} ${user.lastName}`}
            getItemKey={(user) => user.id}
            defaultExpanded={true}
            searchPlaceholder="חפש מרצה..."
            allowSelectAll={multiple}
            allowClear={multiple}
          />

          {/*<FilterExpanderWithListOfCheckboxes
            title="מרצים בחשבון סגור"
            items={professorStatuses?.pending ?? []}
            selectedItems={selectedClosedAccountUsers}
            onItemToggle={handleClosedAccountUserToggle}
            getItemLabel={(user) => user.firstName}
            getItemKey={(user) => user.id}
            searchPlaceholder="חפש מרצה..."
          />*/}
        </div>
      </div>
    );
  },
);
